import { defineStore, type StateTree } from 'pinia';

interface State extends StateTree {
  editPaymentExclusions: boolean;
}

export function usePaymentExclusionsStore(storeId = 'paymentExclusions') {
  const store = defineStore(storeId, {
    state: (): State => ({
      editPaymentExclusions: false,
    }),
    actions: {},
    pagination: false,
  });

  return store();
}
